import React, { useState, useRef } from "react";
import { Tabs, Tab, Col, Row, Pagination, Button } from "react-bootstrap";
import { GetToken } from "../common/getToken";
import { useHistory } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import { useEffect } from "react";
import { SearchInputType, QuestionType, OrderBy, DateRange } from "./Filter";
import moment from "moment";

const QuestionFilterBox = ({
  questionTypes,
  answerTypeId,
  setAnswerTypeId,
  setSearchInputData,
  searchInputData,
  sortBy,
  setSortBy,
  overview,
  surveyDetails,
  BASE_URL,
  surveyId,
}) => {
  const { REACT_APP_BASE_URL } = process.env;
  const { REACT_APP_API_URL } = process.env;

  /* variable declarations */
  //const [questionTypes, setQuestionTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("surveyAnalytics");
  // const [answerTypeId, setAnswerTypeId] = useState();
  const [startDate, setStartDate] = useState();
  const [limit, setLimit] = useState(() => 1);
  const [endDate, setEndDate] = useState();
  // const [sortBy, setSortBy] = useState();
  const [filterButton, setFilterButton] = useState("hide");

  const changeFilterBox = async () => {
    if (filterButton == "hide") {
      setFilterButton("show");
    } else {
      setFilterButton("hide");
    }
  };

  return (
    <>
      <Button
        className="advance-filter k-button k-primary rounded-0 btn-grad btn-grad-blue"
        style={{ float: "right" }}
        onClick={() => changeFilterBox()}>
        {filterButton == "hide" ? "Advance Filter" : "Close Filter"}
      </Button>

      <div className="col-lg-12 advance-filter-main">
        <div className={"advance-filter-sub " + `${filterButton == "hide" ? "d-none" : ""}`}>
          <div className={"filter-download-main bg-white shadow-sm border"}>
            <SearchInputType
              filterTitle="Search by Question"
              setSearchInputData={setSearchInputData}
              searchInputData={searchInputData}
            />
            <QuestionType
              filterTitle="Filter by Question Type"
              questionTypes={questionTypes.map((a) => a.AnswerType)}
              questionTypesData={questionTypes}
              setLimit={setLimit}
              setAnswerTypeId={setAnswerTypeId}
              answerTypeId={answerTypeId}
            />
            {/*}
            <DateRange setStartDate={setStartDate} setEndDate={setEndDate} startDate={startDate} endDate={endDate} />
          {*/}
            <OrderBy filterTitle="Select order" setSortBy={setSortBy} sortBy={sortBy} />
            <Button
              onClick={() => {
                setSearchInputData("");
                setLimit(1);
                setAnswerTypeId(null);
                setStartDate(null);
                setEndDate(null);
                setSortBy(null);
              }}
              className="clear-data shadow-sm"
              variant="danger">
              Reset to Default
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuestionFilterBox;
